import { render, staticRenderFns } from "./BlockMobilePopup.vue?vue&type=template&id=2a7b918a&scoped=true&"
import script from "./BlockMobilePopup.vue?vue&type=script&lang=js&"
export * from "./BlockMobilePopup.vue?vue&type=script&lang=js&"
import style0 from "./BlockMobilePopup.vue?vue&type=style&index=0&id=2a7b918a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7b918a",
  null
  
)

component.options.__file = "BlockMobilePopup.vue"
export default component.exports